module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container",
    style: (_vm.containerStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d73d2fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon-svg/wscn-icon-stack.vue
// module id = 1842
// module chunks = 502